/**
 * Configurazione ambiente di produzione
 */
export const environment = {
  production: true,  // gestisce il log

  LINK_REGISTRAZIONE: 'https://app.primonetwork.it/signup/',
  API_ENDPOINT: 'https://api.ameconvienefinance.it/api',

  // Titolo scheda browser (produzione)
  PAGE_TITLE: 'Auth Ameconviene.it Finance',
  LOGO_HEADER_LIGHT: 'logo_ameconviene_stile_chiaro.webp',
  LOGO_MOBILE_LIGHT: 'logo_ameconviene_stile_chiaro_MOBILE.webp',
  LOGO_HEADER_DARK: 'logo_ameconviene_stile_scuro.webp',
  LOGO_MOBILE_DARK: 'logo_ameconviene_stile_scuro_MOBILE.webp',

  ENABLE_DEBUG_ALERTS: false,
  ENABLE_CONSOLE_LOGS: false,
  //mostra il widget comunicazioni
  SHOW_WIDGET_COMUNICAZIONI: false,
  /** Se true, landing raggruppa i profili per app; se false, una card per profilo */
  RAGGRUPPA_PROFILI: false,
  /** Se true, landing mostra app-portale solo agli utenti con ruolo admin */
  NASCONDI_APP_PORTALE: true,
  /** Coordinamento tab Auth-App (chiusura/overlay disabilitati nel servizio). */
  AMCF_TAB_COORDINATOR_ENABLED: false,
  AMCF_TAB_RESOLVE_MS: 300,
};
